var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cement"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 2",
    cx: 6,
    cy: 1.25,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 3",
    cx: 10.75,
    cy: 1.25,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 5",
    cx: 1.25,
    cy: 6,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 6",
    cx: 6,
    cy: 6,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 7",
    cx: 10.75,
    cy: 6,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 8",
    cx: 1.25,
    cy: 10.75,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 10",
    cx: 6,
    cy: 10.75,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 11",
    cx: 10.75,
    cy: 10.75,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy",
    cx: 3.625,
    cy: 3.625,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 4",
    cx: 8.5,
    cy: 3.625,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 9",
    cx: 3.625,
    cy: 8.25,
    r: 1.25,
    fill: "#00374D"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval Copy 12",
    cx: 8.5,
    cy: 8.25,
    r: 1.25,
    fill: "#00374D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCement);
export default __webpack_public_path__ + "static/media/cement.2843aaf2794cd15c1d737b635ae6d86d.svg";
export { ForwardRef as ReactComponent };